// extracted by mini-css-extract-plugin
module.exports = {"Page":"Page_Page__2AAMi","SvgPreview":"Page_SvgPreview__19cOX"};